import React, { useEffect, useState } from "react"
import {
  Button,
  Col,
  Form,
  Input,
  message,
  Modal,
  notification,
  Row,
  Select,
  Space,
  Table,
} from "antd"
import { unwrapResult } from "@reduxjs/toolkit"
import layout from "antd/lib/layout"
import { useDispatch, useSelector } from "react-redux"
import { RootDispatch } from "../../../app/store"
import { DateSelect } from "../../../compnents/form/DateSelect"
import { CloseOutlined, PlusOutlined, SearchOutlined } from "@ant-design/icons"
import { stringTrim } from "../../../utils/StringUtils"
import FileUpload from "../../../compnents/file/FileUpload"
import Upload, { RcFile } from "antd/lib/upload"
import { UploadFile } from "antd/lib/upload/interface"
import styles from "../filing.module.css"
import axios from "axios"
import {
  selectCredentials,
  selectTenantName,
} from "../../../app/applicationSlice"
import { selectTenant } from "../../user/setting/settingSlice"
import moment from "moment"
import { DateTimeFormatSimpleOnly } from "../../../models/datetime"
import { AXIOS_IP, beforeUploadFile, downloadFile } from "../fileUploadService"
import { PreviewImgOrPdf } from "../Preview"

export const ZYTSLFFormModal = (props: {
  visible: boolean
  token: string
  againId?: string
  memo?: string
  onOk: () => void
  onCancel: () => void
}) => {
  const { Option } = Select

  const { TextArea } = Input

  const dispatch = useDispatch<RootDispatch>()

  const credentials: any = useSelector(selectCredentials)

  const tenantName = useSelector(selectTenantName)

  const tenant = useSelector(selectTenant)

  const [form] = Form.useForm()

  const [doctorVisible, setDoctorVisible] = useState(false)

  const [submitVisible, setSubmitVisible] = useState(false)

  const [fileSBUrl, setfileSBUrl] = useState<any>([]) //管理制度及技术

  const [confirmLoading, setConfirmLoading] = useState(false)

  const [baseUrl, setBaseUrl] = useState("")

  const [previewFile, setPreviewFile] = useState<any>() //预览

  const inputRef = React.useRef<any>(null)

  //申报表模板
  const templateData = {
    fileConfigId: "5",
    fileName: "申报表模板",
    fileType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    filePath: "f47cc2be7fe6e3d910ad6535e54adfebe1b53e8c72a4d2519477130e3f130166.docx",
  }

  // 自定义上传实现
  const customRequest = async (
    { file, onSuccess, onError, onProgress }: any,
    type: string
  ) => {
    const formData = new FormData()
    formData.append("file", file)
    formData.append("name", file.name)
    try {
      // 使用axios发送请求
      const response = await axios.post(
        `${AXIOS_IP}/infra/file/uploadFile`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (progressEvent) => {
            const percent = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            )
            onProgress({ percent })
          },
        }
      )
      if (response.data) {
        const data = response.data
        switch (type) {
          case "SB":
            setfileSBUrl([
              ...fileSBUrl,
              {
                fileConfigId: data?.configId,
                fileName: data?.name,
                fileType: data?.type,
                filePath: data?.path,
              },
            ])
            break
        }
      }
      onSuccess(response.data)
      message.success(`上传成功`)
    } catch (error) {
      message.error(`上传失败`)
    }
  }

  const handleRemove = (type: string, index: number) => {
    switch (type) {
      case "SB":
        setfileSBUrl(fileSBUrl?.filter((v: any, i: number) => i !== index))
        break
    }
  }

  useEffect(() => {
    form.setFieldsValue({
      applicantFile: fileSBUrl,
    })
  }, [fileSBUrl])

  useEffect(() => {
    if (!props.visible) {
      form.resetFields()
      setfileSBUrl([])
    } else {
      if (props.againId) {
        axios({
          url: `${AXIOS_IP}/filingReviewFeature/detail`,
          headers: {
            "Content-Type": "application/json",
            "His-Auth": props.token,
          },
          withCredentials: false,
          method: "POST",
          data: { id: props.againId },
        }).then((res) => {
          if (res.data.data) {
            const data = res.data.data
            form.setFieldsValue({ ...data })
            setfileSBUrl(data?.applicantFile || [])
          }
        })
      } else {
        setTimeout(() => {
          if(inputRef?.current) {
            inputRef.current.focus?.()
          }
        }, 100)
      }
    }
  }, [props.visible])

  return (
    <>
      <Modal
        title="民间中医特色疗法管理"
        width={1000}
        visible={props?.visible}
        onCancel={() => {
          props?.onCancel()
        }}
        onOk={form.submit}
        okText="提交"
        centered
        maskClosable={false}
      >
        <div>
          <Form
            form={form}
            labelCol={{ span: 4 }}
            wrapperCol={{ span: 20 }}
            style={{ paddingRight: 10 }}
            onFinish={(vs) => {
              setSubmitVisible(true)
            }}
          >
            <Row>
              <Col span={24}>
                <Form.Item
                  name="projectName"
                  label="项目名称"
                  rules={[{ required: true }]}
                >
                  <Input ref={inputRef} allowClear />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item
                  name="projectTypeName"
                  label="项目类型"
                  rules={[{ required: true }]}
                >
                  <Input allowClear />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item
                  name="adaptationScope"
                  label="适应范围"
                  rules={[{ required: true }]}
                >
                  <TextArea allowClear showCount maxLength={500} />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item
                  name="usageContraindications"
                  label="使用禁忌"
                  rules={[{ required: true }]}
                >
                  <TextArea allowClear showCount maxLength={500} />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item name="specification" label="应用规范" rules={[{ required: true }]}>
                  <TextArea allowClear showCount maxLength={500} />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item label="传承年数" name="yearsOfInheritance" rules={[{ required: true }]}>
                  <Input allowClear />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item
                  name="algebrasOfInheritance"
                  label="传承代数"
                  rules={[{ required: true }]}
                >
                  <Input allowClear />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item name="contextOfInheritance" label="传承脉络" rules={[{ required: true }]}>
                  <Input allowClear />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item
                  label="申报表"
                  name="applicantFile"
                  rules={[{ required: true }]}
                >
                  <Row align="middle">
                    <Upload
                      customRequest={(options) => customRequest(options, "SB")}
                      beforeUpload={(file) => beforeUploadFile(file, fileSBUrl)}
                      showUploadList={false}
                      maxCount={3}
                      accept={".pdf"}
                    >
                      <Button icon={<PlusOutlined />}>上传</Button>
                    </Upload>
                    <span style={{ padding: "0 10px 0 15px" }}>
                      文件格式为加盖公章的pdf版
                    </span>
                    <a
                      style={{ textDecoration: "underline", paddingRight: 10 }}
                      onClick={() => downloadFile(templateData, props.token, 'docx')}
                    >
                      参考模板
                    </a>
                    {fileSBUrl?.length > 0 &&
                      fileSBUrl?.map((v: any, index: number) => {
                        return (
                          <div
                            key={index}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              cursor: "pointer",
                              paddingRight: 10,
                            }}
                          >
                            <span style={{ paddingRight: 10 }}>
                              {v.fileName}{" "}
                              <a
                                style={{ paddingLeft: 10 }}
                                onClick={() => setPreviewFile(v)}
                              >
                                查看
                              </a>
                            </span>
                            <CloseOutlined
                              style={{
                                position: "relative",
                                top: 2,
                                color: "rgb(161 161 161)",
                              }}
                              onClick={() => {
                                handleRemove("SB", index)
                              }}
                            />
                          </div>
                        )
                      })}
                  </Row>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      </Modal>

      <Modal
        title="提交申请"
        width={600}
        visible={submitVisible}
        onCancel={() => setSubmitVisible(false)}
        confirmLoading={confirmLoading}
        onOk={() => {
          setConfirmLoading(true)
          const data = {
            ...form.getFieldsValue(),
            applicantUserId: credentials.userId,
            applicantUserName: credentials.userName,
            applicantFile: fileSBUrl,
            id: props.againId,
            memo: props.memo,
          }
          axios({
            url: `${AXIOS_IP}/filingReviewFeature/createOrUpdate`,
            headers: {
              "Content-Type": "application/json",
              "His-Auth": props.token,
            },
            withCredentials: false,
            method: "POST",
            data,
          })
            .then(() => {
              setSubmitVisible(false)
              notification.success({
                message: "操作成功",
              })
              props.onOk()
            })
            .finally(() => {
              setConfirmLoading(false)
            })
        }}
        okText="确认提交"
        centered
        maskClosable={false}
      >
        <Row style={{ height: 100 }}>
          提交后请耐心等待工作人员审核，如有任何疑问请拨打400-888888
        </Row>
      </Modal>

      <PreviewImgOrPdf
        token={props.token}
        AXIOS_IP={AXIOS_IP}
        file={previewFile}
        onClose={() => setPreviewFile(null)}
      />
    </>
  )
}
